import AsideEditor from '@UI/editor/AsideEditor';
import type { EditAsideAttachedContent } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideAttachedContent: React.FC<{
  config: EditAsideAttachedContent;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  return (
    <>
      <label className="control-label">{config.label}</label>
      <AsideEditor
        placeholder={`Vul een ${config.label.toLowerCase()} in...`}
        initial={initialValue}
        field="html"
        skey={getResourceKey(editHref)}
        readOnly={readonly}
        showCharacterCount={true}
      />
    </>
  );
};

export default AsideAttachedContent;

AsideAttachedContent.displayName = 'AsideAttachedContent';

AsideAttachedContent.propTypes = {
  config: any,
  readonly: any,
};
